import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGIN_CLEAR_STATE,
  USER_ROLE_REQUEST,
  USER_ROLE_SUCCESS,
  USER_ROLE_FAIL,
  USER_TOKEN,
  SET_SESSION_ID

} from "../types";

const INIT_STATE = {
  userAuth: {},
  userRole: {},
  token: ""
};


const initialState = {
  loading: false,
  token: null,
  sessionId: null,
  error: null
};

export const userAuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_LOGIN_REQUEST:
      return {
        ...state,
        userAuthloading: true,
      };

    case USER_LOGIN_SUCCESS:
      return {
        ...state,
        userAuth: action.payload,
        userAuthloading: false,
      };

    case USER_LOGIN_FAIL:
      return {
        ...state,
        userAuthError: action.payload,
        userAuthloading: false,
      };

    case USER_ROLE_REQUEST:
      return {
        ...state,
        userRoleLoading: true,
      };

    case USER_ROLE_SUCCESS:
      return {
        ...state,
        userRole: action.payload,
        userRoleLoading: false,
      };

    case USER_ROLE_FAIL:
      return {
        ...state,
        userRoleError: action.payload,
        userRoleLoading: false,
      };
    case USER_TOKEN:
      return {
        ...state,
        token: action.payload,
        decodedToken: action.payload.decodedToken
      }
    case SET_SESSION_ID:
      return {
        ...state,
        sessionId: action.payload
      };
    default:
      return state;
  }
};

export default userAuthReducer;
